#import "./TripSupplierFragment.graphql"
fragment TripItemFragment on TripItem {
  id
  _rowTimestamp
  tripId
  _tripSectionId
  tripSectionItemId
  departureStops
  departure1Depot {
    description
    id
  }
  departure2Depot {
    description
    id
  }
  departure3Depot {
    description
    id
  }
  departure4Depot {
    description
    id
  }
  return1Depot {
    description
    id
  }
  return2Depot {
    description
    id
  }
  return3Depot {
    description
    id
  }
  return4Depot {
    description
    id
  }
  returnStops
  departureMiles
  returnMiles
  departureTerminal
  departureTerminalArrival
  returnTerminal
  returnTerminalArrival
  departureArrivalDate
  departureArrivalTime
  pickupArrivalName
  pickupArrivalDropName
  pickupArrivalPrice
  departureDate
  departureTime
  pickupName
  pickupDropName
  pickupPrice
  returnDate
  returnTime
  rentalName
  rentalCityName
  rentalCountryId
  rentalAddress2
  rentalStateRegionId
  rentalAddress1
  rentalTerm
  rentalPrice
  returnDropName
  rentalPostalCode
  returnPrice
  returnName
  returnDropName
  rentalEmailAddress
  rentalTelephoneNumber
  comments
  checkInDate
  returnAddress1
  returnAddress2
  checkInTime
  checkOutDate
  checkOutTime
  returnArrivalDate
  returnArrivalTime
  returnArrivalName
  returnArrivalDropName
  returnArrivalPrice
  bookingFeeQuantity
  bookingFeeRate
  bookingFeeTotal
  perDiemQuantity
  perDiemRate
  perDiemTotal
  incidentalQuantity
  incidentalRate
  incidentalTotal
  miscellaneousQuantity
  miscellaneousRate
  miscellaneousTotal
  itemTotal
  isDepartureEconomyClass
  isDeparturePremiumClass
  isDepartureBusinessClass
  isDepartureFirstClass
  isDepartureCharterClass
  isReturnEconomyClass
  isReturnPremiumClass
  isReturnBusinessClass
  isReturnFirstClass
  isReturnCharterClass
  isDepartureRefundable
  departureAirfare
  returnAirfare
  departureCarrierTripNumber
  returnCarrierTripNumber
  departureCarrierConfirmationCode
  departureArrivalConfirmationCode
  returnArrivalConfirmationCode
  returnCarrierConfirmationCode
  isReturnRefundable
  departureSeat
  returnSeat
  returnEticketNumber
  departureEticketNumber
  pickupDropCurrencyId
  pickupCurrencyId
  returnCurrencyId
  returnDropCurrencyId

  # stops fields
  depart1DepotId
  depart2DepotId
  depart3DepotId
  depart4DepotId
  depart1ArriveDate
  depart2ArriveDate
  depart3ArriveDate
  depart4ArriveDate
  depart1ArriveTime
  depart2ArriveTime
  depart3ArriveTime
  depart4ArriveTime
  depart1DepartDate
  depart2DepartDate
  depart3DepartDate
  depart4DepartDate
  depart1DepartTime
  depart2DepartTime
  depart3DepartTime
  depart4DepartTime
  depart1ArriveTerminal
  depart2ArriveTerminal
  depart3ArriveTerminal
  depart4ArriveTerminal
  depart1DepartTerminal
  depart2DepartTerminal
  depart3DepartTerminal
  depart4DepartTerminal
  return1DepotId
  return2DepotId
  return3DepotId
  return4DepotId
  return1ArriveDate
  return2ArriveDate
  return3ArriveDate
  return4ArriveDate
  return1ArriveTime
  return2ArriveTime
  return3ArriveTime
  return4ArriveTime
  return1DepartDate
  return2DepartDate
  return3DepartDate
  return4DepartDate
  return1DepartTime
  return2DepartTime
  return3DepartTime
  return4DepartTime
  return1ArriveTerminal
  return2ArriveTerminal
  return3ArriveTerminal
  return4ArriveTerminal
  return1DepartTerminal
  return2DepartTerminal
  return3DepartTerminal
  return4DepartTerminal
  # stops fields
  currency {
    id
    isoCode
    currencySymbol
  }
  tripSection {
    layoutType
    id
    sortOrder
    name
    _isUpdatable
    description
  }
  departureDepotId
  departureDepot {
    description
  }
  departureArrivalDepotId
  departureArrivalDepot {
    description
  }
  departureCarrierId
  departureCarrier {
    description
  }
  returnDepotId
  returnDepot {
    description
  }
  returnArrivalDepotId
  returnArrivalDepot {
    description
  }
  returnCarrierId
  returnCarrier {
    description
  }
  isSupplierBreakdownRequired
  supplierId
  pickupSupplierId
  pickupDropSupplierId
  returnDropSupplierId
  returnSupplierId
  supplier {
    ...TripSupplierFragment
    _isAliasOriginalNameViewable
    _isAliasInvoked
  }
  pickupSupplier {
    ...TripSupplierFragment
  }
  pickupDropSupplier {
    ...TripSupplierFragment
  }
  returnDropSupplier {
    ...TripSupplierFragment
  }
  returnSupplier {
    ...TripSupplierFragment
  }
  _tripSectionLayout
  tripDistributions {
    nodes {
      id
      _createdDate
      _isDeletable
      _isUpdatable
      _rowTimestamp
      distributionAmount
      productionIncentiveId
      projectReference
      tax1099T4TypeId
      tripItemId
      projectId
      accountId
      setAccountId
      referenceCode1Id
      referenceCode2Id
      referenceCode3Id
      referenceCode4Id
      referenceCode5Id
      referenceCode6Id
      referenceCode7Id
      accountReference
      _accountName
      setReference
      referenceCode1
      referenceCode2
      referenceCode3
      referenceCode4
      referenceCode5
      referenceCode6
      referenceCode7
      additionalDescription
      allocationPercent
      currencyId
      tripSectionId
    }
  }
  isPreferredSupplier
  preferredRateTypeId
  isExceptionRequired
  exceptionComments
}
